<template>
  <a-layout id="app">
    <Header :isAuthenticated="isAuthenticated" @onBrandClick="goToHome">
      <template v-slot:brand>
        <img src="@/assets/eos_gmbh_logo.svg" />
        <h1>Developer Network</h1>
      </template>
      <template v-slot:links>
        <div v-if="!isAuthenticated">
          <Button @onClick="signIn" class="button" type="primary"
            >Sign in</Button
          >
        </div>
        <div v-else>
          <!--
            SCHLMI 2021.11.03 we don't need the dashboard for the moment. For that reason,
            I've disabled the dashboard. 
          <router-link data-test="dashboard" to="/dashboard"
            >Dashboard</router-link
          >-->
          <router-link data-test="my-session" to="/session"
            >MySession</router-link
          >
          <router-link data-test="my-session" to="/resources"
            >Resources</router-link
          >
          <router-link data-test="profile" to="/account/profile"
            >MyProfile</router-link
          >
          <a
            v-show="currentUser && currentUser.isActive && currentUser.isAdmin"
            :href="externalAdminUrl"
            data-test="admin"
            target="_blank"
            >Admin</a
          >
          <a href="#" @click="signOut">
            <font-awesome-icon icon="sign-out-alt" class="sign-out-icon" />
            Log Out
          </a>
        </div>
      </template>
    </Header>
    <a-layout-content class="content">
      <router-view :current-user="currentUser" />
    </a-layout-content>
    <!--<Footer></Footer>-->
  </a-layout>
</template>

<script>
// import { tokenRequest } from "@/config/authConfig";
import Button from "@/components/Button";
import Header from "@/components/Header";
//import Footer from "@/components/Footer";
import axios from "@/api/index";
import { getMyUser } from "@/api/users";
import { tokenRequest, REACT_ADMIN_URL } from "@/config/authConfig";
import { ONE_MINUTE } from "@/config/time";

export default {
  components: {
    Button,
    Header
    //Footer
  },
  data() {
    return {
      isAuthenticated: this.$msal.isAuthenticated(),
      currentUser: null,
      externalAdminUrl: REACT_ADMIN_URL,
      accessToken: null,
      retryCount: 0
    };
  },
  updated() {
    this.isAuthenticated = this.$msal.isAuthenticated();
  },
  mounted() {
    if (this.$msal.isAuthenticated()) {
      this.setInterceptor();
      this.getToken();

      setInterval(() => {
        this.getToken();
      }, ONE_MINUTE * 10);
    }
  },
  beforeDestroy() {},
  methods: {
    signIn() {
      this.$msal.signIn();
    },
    signOut() {
      this.$msal.signOut();
    },
    goToHome() {
      this.$router.push({ path: "/" });
    },
    async fetchUser() {
      try {
        const response = await getMyUser(this.accessToken);
        this.currentUser = response.data;
        this.$store.commit("setCurrentUser", response.data);
        if (this.currentUser && !this.currentUser.isActive) {
          this.signOut();
        }
      } catch (error) {
        if (error && error.response && error.response.status === 403) {
          return this.signOut();
        }
        this.$notification.error({
          message: error.message || "Could not get user",
          description: "Unable to retrieve user details"
        });
      }
    },
    getToken() {
      this.$msal
        .acquireToken(tokenRequest, 7)
        .then(userData => {
          // console.log("we are here");
          axios.defaults.headers.common["Authorization"] = "";
          this.accessToken = userData.accessToken;
          axios.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${userData.accessToken}`;
          this.accessToken = userData.accessToken;
          // console.log("getting token...");
          this.fetchUser();
        })
        .catch(err => {
          this.$notification.error({
            message: err.message || "Could not get user",
            description: "Unable to retrieve user details"
          });
        });
    },
    setInterceptor() {
      axios.interceptors.response.use(
        response => {
          return response;
        },
        async err => {
          const originalReq = err.config;
          if (originalReq.__retryCount > 5) {
            this.signOut();
            return;
          } else if (this.retryCount >= 20) {
            this.signOut();
            return;
          }

          if (
            err &&
            err.response &&
            err.response.status === 401 &&
            originalReq &&
            !originalReq.__isRetryRequest
          ) {
            originalReq._retry = true;
            originalReq.__retryCount = isNaN(originalReq.__retryCount)
              ? 1
              : originalReq.__retryCount + 1;
            this.retryCount = this.retryCount + 1;
            console.log("intercepting...", this.retryCount);
            const newUserData = await this.$msal.acquireToken(tokenRequest, 7);
            axios.defaults.headers.common["Authorization"] = "";
            axios.defaults.headers.common[
              "Authorization"
            ] = `Bearer ${newUserData.accessToken}`;
            this.accessToken = newUserData.accessToken;
            originalReq.headers[
              "Authorization"
            ] = `Bearer ${newUserData.accessToken}`;
            return axios.request(originalReq);
          }
          return Promise.reject(err);
        }
      );
    }
  }
};
</script>

<style lang="scss">
@import "./styles/_variables.scss";

#app {
  font-family: "Open Sans", sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100vh;
  background-color: #ffffff;
}

.content {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: $navbarHeight;
}

// make sure that notifications are always on top
.div.ant-notification-notice-message {
  z-index: 30;
}
</style>
